import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsOptional, IsString } from "class-validator";

export class LogoutUserDto { 
    @ApiProperty()
    @IsNotEmpty()
    @IsString()
    readonly username: string;

    @ApiPropertyOptional()
    @IsOptional()
    @IsString()
    readonly sessionId?: string;
}
